<template>
  <div class="my-left">
    <div class="my-bg">
      <el-image class="img-bg" fit="cover" :src="avatar || require('../../assets/images/mybg.jpg')"></el-image>
      <div class="btn-group">
        <el-button type="primary" icon="el-icon-edit" size="mini" @click="toUrl('/my/userinfo')">编辑</el-button>
<!--        <el-button type="primary" icon="el-icon-share" size="mini">分享</el-button>-->
      </div>
      
    </div>
    <el-image class="avatar" fit="cover" :src="avatar || require('../../assets/images/avatar.png')"></el-image>
    <div class="username">{{username}}</div>
    <div class="info-con z-flex">
      <div class="item" v-for="(item,index) in menuList" :key="index">
        <div class="num">{{item.num}}</div>
        <div class="text">{{item.title}}</div>
      </div>
    </div>
    <div class="vip-con">
      <div class="item z-flex" v-if="starName">
        <div class="item-l">
          <img class="icon" src="@/assets/images/i-marvel.png"/>
        </div>
        <div class="item-r">{{starName}}</div>
      </div>
      <div class="item z-flex">
        <div class="item-l">
          <img class="icon" src="@/assets/images/i-vip3.png"/>
          <span class="text" v-if="vipName!='普通用户'">{{vipLevel}}</span>
        </div>
        <div class="item-r">{{vipName}}</div>
      </div>
      <div class="item z-flex">
        <div class="item-l">
          <img class="icon" src="@/assets/images/i-vip2.png"/>
        </div>
        <div class="item-r z-flex z-flex-between">
          <div>
            <span v-if="vipName!='普通用户'">会员有效期：{{limitDate}}</span>
            <span v-else>开通会员享更多权益</span>
          </div>
          <el-button type="primary" size="mini" @click="buyVip">{{vipName!='普通用户'?'立即续费':'立即开通'}}</el-button>
        </div>
      </div>
      <div class="item item-match-type z-flex">
        <div class="item-l">
          <img class="icon" src="@/assets/images/i-match.png"/>
        </div>
        <div class="item-r z-flex">
          <span class="item-r-label">投稿类型</span>
          <el-popover
            trigger="click"
            ref="popMatchType"
          >
            <el-input class="match-type-ipt" v-model="matchTypeStr" placeholder="选择投稿类型" size="medium" readonly suffix-icon="el-icon-arrow-down" slot="reference"></el-input>
            <div class="match-type-list">
              <el-checkbox v-model="matchTypeAll" @change="selMatchTypeAll">全部赛事</el-checkbox>
              <el-checkbox-group v-model="matchType" @change="selMatchType">
                <el-checkbox v-for="(item,index) in matchTypeList" :label="item" :key="index">{{item}}</el-checkbox>
              </el-checkbox-group>
            </div>
            <el-button 
              class="btn-confirm" 
              style="width:60%;display:block;margin:10px auto 0;" 
              type="primary" 
              size="mini" 
              @click="confirmMatchType"
            >
              确认
            </el-button>
          </el-popover>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions} from "vuex";
export default {
  name: "myLeft",
  props: {
    
  },
  data() {
    return {
      avatar:require('../../assets/images/mybg.jpg'),
      username:'',
      starName:'',
      vipName:'',
      vipLevel:1,
      limitDate:'2023-12-12',
      menuList:[
        {
          title:'获奖投稿',
					num:0,
        },{
          title:'赛事奖金',
					num:0,
        },{
          title:'图片收益',
					num:0,
        },
      ],
      //投稿类型
      matchTypeList:['奖金赛事','国协赛事','省协赛事','其他赛事'],
      matchType:[],
      matchTypeAll:false,
    };
  },
  mounted() {
    this.$axios.api.getUserInfo({}, (res) => {
      if (res.code == 200) {
        this.username = res.data.nickname ? res.data.nickname : res.data.username;
        this.avatar = res.data.avatar;
        this.vipName = res.data.vip_name;
        this.limitDate = res.data.limit_date;
        this.starName = res.data.qtclub_win_star_name;
        this.menuList[0].num = res.data.winner_num;
        this.menuList[1].num = res.data.winner_amount;
        this.matchType = res.data.match_subtype;
        if(this.matchType.length==this.matchTypeList.length){
          this.matchTypeAll = true;
        }else{
          this.matchTypeAll = false;
        }
      }
    });
  },
  watch: {
    // "vuex_user": {
    //   handler(newVal, oldVal){
  
    //   }
    // }
  },
  computed: {
    ...mapState(['vuex_user']),

    matchTypeStr:{
      get(){
        if(this.matchTypeAll){
          return '全部赛事'
        }else{
          return this.matchType.join(',')
        }
      },
      set(){}
    },
  },
  methods: {
    ...mapActions(['vuexUserLogin', 'vuexUserLogout', 'vuexInitLocalUser']),
    toUrl(url){
      this.$router.push({
        path:url,
      })
    },
    // 购买会员
    buyVip(){
      this.$parent.$parent.showPayCombo();
      // return this.$parent.$parent.confirmToPay({
      //   platform: 'proxy_match',
      //   combo_id: 9,
      //   recharge_type: 5,
      //   price: 1999,
      // });
    },
    //投稿类型
    selMatchType(e){
      // console.log(e);
      if(e.length>=this.matchTypeList.length){
        this.matchTypeAll = true;
      }else{
        this.matchTypeAll = false;
      }
      //向父页面传参
      // this.$emit('selMatchType',e);
    },
    selMatchTypeAll(e){
      if(e===true){
        this.matchType = [];
        this.matchTypeList.map((item)=>{
          this.matchType.push(item);
        })
      }else{
        this.matchType = [];
      }
    },
    confirmMatchType(){
      this.$axios.api.request({
        url: "/api/qtclub/user/submitSubtype",
        method: "POST",
        data: {
          subtype: this.matchType,
        }
      }, (res) => {
        if(res.code == 200){
          this.$message.success('设置成功！');
          this.$refs.popMatchType.handleBlur();
        }else{
          this.$message.console.error(res.msg);
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.my-left{
  width: 330px;
  background:#fff;
  border-radius: 4px;
  overflow: hidden;
  .my-bg{
    width: 100%;
    height:130px;
    overflow: hidden;
    position: relative;
    .img-bg{
      width: 120%;
      height: 120%;
      object-fit: cover;
      filter: blur(20px);
    }
    .btn-group{
      position: absolute;
      right: 8px;
      top: 8px;
      .el-button{
        padding: 7px;
      }
    }
  }
  .avatar{
    width: 90px;
    height: 90px;
    object-fit: cover;
    border-radius: 100%;
    border: 2px solid #fff;
    display: block;
    margin: -50px auto 0;
    position: relative;
    z-index: 1;
  }
  .username{
    text-align: center;
    margin:20px;
    @extend %textOverflow;
  }
  .info-con{
    .item{
      width:33.33%;
      text-align: center;
      border-bottom: $borderLight;
      padding-bottom: 20px;
      .num{
        font-size:16px;
        font-family: Arial, Helvetica, sans-serif;
      }
      .text{
        color: #999;
        font-size: 14px;
      }
    }
  }
  .vip-con{
    .item{
      padding: 15px 0;
      margin:0 15px;
      border-bottom: $borderLight;
      .item-l{
        position: relative;
        width:20px;
        .icon{
          width:20px;
          height:20px;
        }
        .text{
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%,-50%);
          font-size: 12px;
          color: #d24500;
          font-family: Arial, Helvetica, sans-serif;
          font-weight: 700;
          margin-top: -1px;
        }
      }
      .item-r{
        font-size: 14px;
        margin-left: 20px;
        color: #666;
        flex: 1;
      }
      &:last-child{
        border: none;
      }
      &.item-match-type{
        .item-r{
          ::v-deep .el-select{
            flex: 1;
            .el-input__inner{
              border-top-left-radius: 0;
              border-bottom-left-radius: 0;
            }
          }
          .item-r-label{
            height: 36px;
            line-height: 36px;
            padding:0 10px;
            border: 1px solid #DCDFE6;
            background-color: #f5f7fa;
            color: #909399;
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
            border-right: none;
            box-sizing: border-box;
          }

          .match-type-ipt{
            ::v-deep .el-input__inner{
              width:180px;
              border-top-left-radius: 0;
              border-bottom-left-radius: 0;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
.match-type-list{
  .el-checkbox{
    width:100%;
    display: flex;
    padding: 5px 0;
    box-sizing: border-box;

  }
}
</style>
